import { useEffect, useState } from "react";
import { API } from "@/apiConfig";
import { CashDropDialog } from "@/components/pos/CashDropDialog";

// Sits in the same reserved slot as CentralStatusIndicator. Turns dark red with
// big white text once uncollected cash crosses the configured threshold.
export default function CashDropButton() {
  const [status, setStatus] = useState(null);
  const [open, setOpen] = useState(false);

  const poll = async () => {
    try {
      const stationId = localStorage.getItem("station_id") || "default";
      const res = await fetch(`${API}/reports/cash-drop-status?station_id=${stationId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` },
      });
      if (res.ok) setStatus(await res.json());
    } catch { /* silent — button just stays in its last known state */ }
  };

  useEffect(() => {
    poll();
    const t = setInterval(poll, 20000);
    return () => clearInterval(t);
  }, []);

  const needsDrop = !!status?.needs_drop;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid="cash-drop-button"
        className={`px-3 py-1.5 rounded-lg font-bold transition-colors ${
          needsDrop
            ? "bg-red-900 text-white text-base animate-pulse"
            : "bg-orange-500 text-black text-sm"
        }`}
        title={needsDrop ? `$${status.cash_since_last_drop?.toFixed(2)} uncollected — drop now` : "Cash Drop"}
      >
        Cash Drop
      </button>
      <CashDropDialog open={open} onOpenChange={setOpen} onComplete={poll} />
    </>
  );
}
